import axios from 'axios';
import { AUTH_API_PREFIX } from '../consts';

export async function getPassJwk() {
  return axios.get(`${AUTH_API_PREFIX}/.well-known/pass-jwk`).then((response) => response.data);
}
